import {
    Card,
    CardContent,
    Typography,
    Box,
    IconButton
} from '@material-ui/core';

export const MobileCard = ({ record, config, onClick }) => {
    const renderValue = (field) => {
        if (!field) return null;
        if (typeof field === 'function') return field(record);
        return record?.[field];
    };
    return (
        <Card elevation={0} style={{ margin: 0, border: '1px solid #e0e0e0' }} onClick={() => onClick(record)}>
            <CardContent>
                <Box display="flex" justifyContent="space-between">
                    <Box flex={1}>
                        {config.title && (
                            <Typography variant="subtitle1">
                                {renderValue(config.title)}
                            </Typography>
                        )}

                        {config.subtitle && (
                            <Typography variant="body2" color="textSecondary">
                                {renderValue(config.subtitle)}
                            </Typography>
                        )}
                    </Box>

                    {config.right && (
                        <Box textAlign="right">
                            {renderValue(config.right)}
                        </Box>
                    )}
                </Box>

                {config.lines?.map((line, i) => (
                    <Typography key={i} variant="caption" display="block">
                        {renderValue(line)}
                    </Typography>
                ))}

                {config.action && (
                    <Box display="flex" justifyContent="flex-end" mt={1}>
                        <IconButton
                            size="small"
                            onClick={() => config.action.onSwipe(record)}
                        >
                            {config.action.icon}
                        </IconButton>
                    </Box>
                )}
            </CardContent>
        </Card>
    );
};